import { render } from "./Habilitacion.vue?vue&type=template&id=5a8a79a6"
import script from "./Habilitacion.vue?vue&type=script&lang=js"
export * from "./Habilitacion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__